module.exports = __webpack_public_path__ + "media/en_Beta Digitis - Gif.gif.1934d785.mp4";